import { render, staticRenderFns } from "./FacebookChat.vue?vue&type=template&id=632a4979&scoped=true&"
import script from "./FacebookChat.vue?vue&type=script&lang=js&"
export * from "./FacebookChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632a4979",
  null
  
)

export default component.exports